import ThemeProvider from './ThemeProvider';
import composeStyles from './composeStyles';
import { Theme as actualTheme } from './theme';

export * from './mixins';
export type Theme = actualTheme;
export { composeStyles };
export default ThemeProvider;
